<!--
 * @Author: shiao
 * @LastEditors: shiao
 * @FilePath: \o2o-app\src\components\nocity.vue
-->
<template>
  <div>
    <div class="searchno-div">
      <div class="searchno-img"><img :src="nocityicon" alt="" /></div>
      <div class="searchno-div-text">{{nofindtext}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'nocity',
  props:{
    nofindtext:{
        type:String,
        default:'抱歉，没有找到相关城市'
      }
  },
  data() {
    return {
      nocityicon: require("@/assets/shared-hotel/searchno.png"), //搜索结果无城市图片
    };
  },
};
</script>

<style scoped lang='less'>
.searchno-div {
  margin: 50px auto 0;
  text-align: center;
  .searchno-img {
    img {
      width: 126px;
      height: 126px;
    }
  }
  .searchno-div-text {
    text-align: center;
    height: 21px;
    font-size: 15px;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
    margin: 48px auto 0;
  }
}
</style>